export const DISCORD_URL = "https://discord.gg/fivem-mshop";

// Anchor targets — labels come from translations (t.nav)
export const NAV_LINKS = [
  { key: "products", href: "#products" },
  { key: "howItWorks", href: "#how-it-works" },
];

// Non-text product config (order + presentation). Text lives in i18n translations.
export const PRODUCTS = [
  { id: "advanced-electrician-job", icon: "Zap", popular: true, image: "https://images.pexels.com/photos/36571389/pexels-photo-36571389.jpeg" },
  { id: "basic-package", icon: "Wrench", image: "https://images.pexels.com/photos/36571389/pexels-photo-36571389.jpeg" },
  { id: "medium-package", icon: "Code2", image: "https://images.pexels.com/photos/4218883/pexels-photo-4218883.jpeg" },
  { id: "advanced-package", icon: "Sparkles", image: "https://images.pexels.com/photos/36571389/pexels-photo-36571389.jpeg" },
  { id: "bug-error-fixes", icon: "Bug", image: "https://images.pexels.com/photos/36571389/pexels-photo-36571389.jpeg" },
  { id: "resource-db-optimization", icon: "Gauge", image: "https://images.pexels.com/photos/4218883/pexels-photo-4218883.jpeg" },
  { id: "monthly-maintenance", icon: "ShieldCheck", image: "https://images.pexels.com/photos/4218883/pexels-photo-4218883.jpeg" },
  { id: "dedicated-developer", icon: "CalendarDays", image: "https://images.pexels.com/photos/4218883/pexels-photo-4218883.jpeg" },
];

// Step numbers + icons (text from translations)
export const STEPS = [
  { n: "01", icon: "MessageCircle" },
  { n: "02", icon: "Zap" },
  { n: "03", icon: "ShieldCheck" },
];
